import * as types from "./types"

class Schema extends types.Shape {}

/**
 * Basic types
 */
Schema.types = types

/**
 * Stringify schema
 */
Schema.stringify = function stringify() {
  return JSON.stringify(this)
}

/**
 * Take each object value, which corresponds required type by scheme,
 * call handler with that value and then save returned value back,
 */
Schema.mapObjectByTypeRecursive = function mapObjectByTypeRecursive(
  data,
  schema,
  requiredType,
  handler,
) {
  if (!(schema instanceof types.Shape)) {
    throw new Error(`Schema should be an instanceof Shape`)
  }

  const keys = Object.keys(data)

  const nextData = {}

  for (let i = 0; i < keys.length; i += 1) {
    const keySchema = schema.properties[keys[i]]

    if (keySchema && keySchema instanceof requiredType) {
      nextData[keys[i]] = handler(data[keys[i]], keySchema, data)
    } else if (keySchema && keySchema instanceof types.Shape) {
      nextData[keys[i]] = Schema.mapObjectByTypeRecursive(
        data[keys[i]],
        keySchema,
        requiredType,
        handler,
      )
    } else {
      nextData[keys[i]] = data[keys[i]]
    }
  }

  return nextData
}

/**
 * Check schema is instance of Schema
 */
Schema.isSchema = function isSchema(schema) {
  return !(schema instanceof types.Any)
}

export default Schema
